const isAndroidOrIosSystem = (): boolean => {
    if (typeof navigator === 'undefined') return false;

    const ua = navigator.userAgent || navigator.vendor || '';
    const platform = navigator.platform || '';

    const isAndroid = /android/i.test(ua) || /android/i.test(platform);
    const isIosUA = /iPhone|iPad|iPod/i.test(ua) || /iPhone|iPad|iPod/i.test(platform);
    const isIpadOs = /Macintosh/i.test(platform) && navigator.maxTouchPoints > 1;

    return isAndroid || isIosUA || isIpadOs;
};

export const isMobileSystem = (): boolean => {
    return isAndroidOrIosSystem();
};

export const getDefaultRedirectPath = (): string => {
    return isMobileSystem() ? '/mobile' : '/dashboard';
};
